/* eslint-disable quotes */
import React from "react";
import PropTypes from "prop-types";
import { ChatIcon, TrashIcon } from "@heroicons/react/outline";

const CommentListItem = ({ comment, maxWidth, onDelete }) => {
  //fix " on comment
  console.log("key", comment);
  let commentText = comment.comment.replace('"', '"');
  //fix linebreakd
  commentText = commentText.split("\\n").map((str) => (
    <p key={str} className="content__line">
      {str}
    </p>
  ));
  //fix date
  const createdAtVal = new Date(comment.createdAt).toLocaleDateString("sv-SE");

  console.log("comment", comment);
  return (
    <li
      className={
        comment.usrType === "employee" ? "commentItem" : "commentItem reverse"
      }
    >
      <div className="commentIcon">
        <ChatIcon className="standardSquareIcon" />
      </div>
      <div style={{ maxWidth: maxWidth }}>
        {comment.showBin && (
          <span className="pointer" onClick={onDelete}>
            <TrashIcon className="standardSquareIcon" /> Radera
          </span>
        )}
        <div className="commentInfo">
          <span className="authorInfo">
            {comment.author} - {comment.organisation}{" "}
          </span>
          <span className="date">{createdAtVal}</span>
        </div>
        <div className="content">{commentText}</div>
      </div>
    </li>
  );
};

CommentListItem.propTypes = {
  comment: PropTypes.shape({
    comment: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    usrType: PropTypes.string.isRequired,
    showBin: PropTypes.bool,
    author: PropTypes.string.isRequired,
    organisation: PropTypes.string.isRequired,
  }).isRequired,
  maxWidth: PropTypes.string,
  onDelete: PropTypes.func,
};

export default CommentListItem;
